import { useCallback, useRef } from 'react';

export function useDragToScroll<T extends HTMLElement>() {
  const ref = useRef<T | null>(null);
  const stateRef = useRef({ down: false, startX: 0, startScroll: 0, moved: false });

  const onMouseDown = useCallback((e: React.MouseEvent<T>) => {
    const el = ref.current;
    if (!el) return;
    stateRef.current.down = true;
    stateRef.current.moved = false;
    stateRef.current.startX = e.pageX - el.offsetLeft;
    stateRef.current.startScroll = el.scrollLeft;
  }, []);

  const stop = useCallback(() => {
    stateRef.current.down = false;
  }, []);

  const onMouseMove = useCallback((e: React.MouseEvent<T>) => {
    const el = ref.current;
    if (!el || !stateRef.current.down) return;
    e.preventDefault();
    const x = e.pageX - el.offsetLeft;
    const walk = x - stateRef.current.startX;
    if (Math.abs(walk) > 3) stateRef.current.moved = true;
    el.scrollLeft = stateRef.current.startScroll - walk;
  }, []);

  const onClickCapture = useCallback((e: React.MouseEvent<T>) => {
    if (stateRef.current.moved) {
      e.preventDefault();
      e.stopPropagation();
      stateRef.current.moved = false;
    }
  }, []);

  return {
    ref,
    handlers: {
      onMouseDown,
      onMouseMove,
      onMouseLeave: stop,
      onMouseUp: stop,
      onClickCapture,
    },
  };
}
